import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createFileset, updateFileset } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import FilesetForm from './FilesetForm';

const FORM_ID = 'filesetForm';

export class FilesetFormContainer extends React.Component {
  static propTypes = {
    isNewFileset: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    recordLevelTypes: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
    datasetId: PropTypes.number.isRequired,
    preExistingValues: PropTypes.object.isRequired,
    createFilesetAction: PropTypes.func.isRequired,
    pageChangeFunction: PropTypes.func.isRequired,
    updateFilesetAction: PropTypes.func.isRequired,
  };

  performCreateFileset = params => {
    const { createFilesetAction, datasetId } = this.props;
    const token = storeWithExpiration.get('token');
    const filesetInfo = {
      dataFilenamePattern: params.dataFilenamePattern,
      layoutFilename: '',
      recordLevelTypeId: params.recordLevelTypeId,
    };
    createFilesetAction(token, filesetInfo, datasetId);
  };

  updateFileset = params => {
    const { updateFilesetAction, datasetId, preExistingValues } = this.props;
    const token = storeWithExpiration.get('token');
    const filesetInfo = {
      dataFilenamePattern: params.dataFilenamePattern,
      layoutFilename: '',
      recordLevelTypeId: params.recordLevelTypeId,
    };
    updateFilesetAction(token, filesetInfo, datasetId, preExistingValues.id);
  };

  render() {
    const {
      invalid,
      handleSubmit,
      submitting,
      isNewFileset,
      recordLevelTypes,
      pageChangeFunction,
    } = this.props;

    return (
      <div className="card card-block">
        <h2 className="card-title">{isNewFileset ? 'Create New Fileset' : 'Update Fileset'}</h2>
        <FilesetForm
          invalid={invalid}
          handleSubmit={handleSubmit}
          submitting={submitting}
          submitFunction={isNewFileset ? this.performCreateFileset : this.updateFileset}
          isNewFileset={isNewFileset}
          recordLevelTypes={recordLevelTypes}
          pageChangeFunction={pageChangeFunction}
        />
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.dataFilenamePattern || values.dataFilenamePattern === '') {
    errors.dataFilenamePattern = 'Required';
  }
  if (!values.recordLevelTypeId || values.recordLevelTypeId === '') {
    errors.recordLevelTypeId = 'Required';
  }
  return errors;
};

function mapStateToProps(state) {
  const { superadmin } = state;
  const filesetValues = superadmin.get('filesetValues');
  const initialValues = {
    id: filesetValues.id,
    datasetId: filesetValues.datasetId,
    dataFilenamePattern:
      filesetValues.dataFilenamePattern === null ? '' : filesetValues.dataFilenamePattern,
    recordLevelTypeId:
      filesetValues.recordLevelTypeId === null ? 0 : filesetValues.recordLevelTypeId,
  };
  return { initialValues };
}

const FilesetFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(FilesetFormContainer);

export default connect(mapStateToProps, {
  createFilesetAction: createFileset,
  updateFilesetAction: updateFileset,
})(FilesetFormContainerRF);
